export const HubspotMixin = {
  data() {
    return {
      hubspotConversationLoaded: false,
    };
  },
  mounted() {
    if (window.HubSpotConversations) {
      this.onConversationsAPIReady();
    } else {
      window.hsConversationsOnReady = [this.onConversationsAPIReady];
    }
  },
  methods: {
    async openHubspotWidget(name = "") {
      // TODO
      // logEvent.handleWriteToMixpanel("Chat");
      this.hubspotConversationLoaded = true;
      window.HubSpotConversations.widget.load({ widgetOpen: true });
    },
    onConversationsAPIReady() {
      window.hsConversationsSettings = {
        loadImmediately: false,
      };
    },
  },
};
